'use client'

import * as React from 'react'
import { format } from 'date-fns'
import { CalendarIcon } from 'lucide-react'
import { DateRange } from 'react-day-picker'
import { Popover, PopoverContent, PopoverTrigger } from '../utils/components/ui/popover'
import { Button } from '../utils/components/ui/button'
import { Calendar } from '../utils/components/ui/calendar'
import { cn } from '../utils/cn'

interface DateRangePickerProps {
  className?: string
  value?: DateRange
  onChange?: (range: DateRange | undefined) => void
}

export function DateRangePicker({
  className,
  value,
  onChange,
}: DateRangePickerProps) {
  const [internalDate, setInternalDate] = React.useState<DateRange | undefined>(
    // value ?? {
    //   from: new Date(),
    //   to: new Date(),
    // }
  )

  React.useEffect(() => {
    if (value) {
      setInternalDate(value)
    }
  }, [value])

  const handleSelect = (range: DateRange | undefined) => {
    setInternalDate(range)
    onChange?.(range)
  }

  return (
    <div className={cn('grid gap-2', className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant={'outline'}
            className={cn(
              'w-[200px] justify-center gap-2 text-left font-normal bg-[#F5F5F5] text-[#84928C]',
              !internalDate && 'text-muted-foreground'
            )}
          >
            {internalDate?.from ? (
              internalDate.to ? (
                <>
                  {format(internalDate.from, 'LLL dd, y')} -{' '}
                  {format(internalDate.to, 'LLL dd, y')}
                </>
              ) : (
                format(internalDate.from, 'LLL dd, y')
              )
            ) : (
              <span>Quote Date</span>
            )}
            <CalendarIcon className="mr-2 h-4 w-4 text-[#84928C]" />

          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={internalDate?.from}
            selected={internalDate}
            onSelect={handleSelect}
            numberOfMonths={2}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}
